import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import PageHero from "../../components/pageHero/PageHero";
import Reveal from "../../components/reveal/Reveal";
import ContactForm, { EMAIL } from "../../components/contactForm/ContactForm";
import { greeting, socialMediaLinks, contactPageData } from "../../portfolio.js";
import "./ContactComponent.css";

const ContactData = contactPageData.contactSection;
const addressSection = contactPageData.addressSection;
const phoneSection = contactPageData.phoneSection;
const channels = socialMediaLinks.filter((s) =>
  ["Github", "LinkedIn"].includes(s.name)
);

class CopyEmail extends Component {
  state = { copied: false };
  copy = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      this.setState({ copied: true });
      setTimeout(() => this.setState({ copied: false }), 2000);
    } catch (e) {
      /* clipboard blocked */
    }
  };
  render() {
    return (
      <button type="button" className="copy-btn" onClick={this.copy}>
        {this.state.copied ? "Copied ✓" : "Copy"}
      </button>
    );
  }
}

class Contact extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="contact-main">
        <Header theme={theme} />
        <PageHero
          kicker="Contact"
          title="Let's build something together"
          description={ContactData.description}
        />
        <div className="page-wrap">
          <div className="contact-layout">
            <Reveal className="reveal-fill">
              <ContactForm />
            </Reveal>

            <aside className="contact-side">
              <Reveal delay={100}>
                <div className="contact-card">
                  <h3>Email</h3>
                  <p className="contact-line">
                    <a className="contact-link" href={`mailto:${EMAIL}`}>{EMAIL}</a>
                    <CopyEmail />
                  </p>
                </div>
              </Reveal>
              <Reveal delay={180}>
                <div className="contact-card">
                  <h3>{phoneSection.title}</h3>
                  <p>
                    <a className="contact-link" href={`tel:${phoneSection.subtitle.replace(/\s/g, "")}`}>
                      {phoneSection.subtitle}
                    </a>
                  </p>
                </div>
              </Reveal>
              <Reveal delay={260}>
                <div className="contact-card">
                  <h3>{addressSection.title}</h3>
                  <p>{addressSection.subtitle}</p>
                  <p className="contact-sub">
                    <a
                      className="contact-link"
                      href={addressSection.location_map_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open in Google Maps ↗
                    </a>
                  </p>
                </div>
              </Reveal>
              <Reveal delay={340}>
                <div className="contact-card">
                  <h3>Elsewhere</h3>
                  <div className="contact-socials">
                    {channels.map((s) => (
                      <a
                        key={s.name}
                        className="contact-social"
                        href={s.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {s.name === "Github" ? "GitHub" : s.name} <span aria-hidden="true">↗</span>
                      </a>
                    ))}
                    <a
                      className="contact-social"
                      href={greeting.resumeLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Résumé <span aria-hidden="true">↗</span>
                    </a>
                  </div>
                </div>
              </Reveal>
            </aside>
          </div>
        </div>
        <Footer theme={theme} />
        <TopButton theme={theme} />
      </div>
    );
  }
}

export default Contact;
